import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";

export default function SetPlayerMembershipGrantDialog({
  openState,
  userContext,
  onClose,
  onGrantMembership,
}) {
  const [tier, setTier] = useState("premium");
  const [durationDays, setDurationDays] = useState(365);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (openState) {
      setTier("premium");
      setDurationDays(365);
      setSubmitting(false);
      setError("");
    }
  }, [openState, userContext?.userId]);

  if (!("row" in userContext)) {
    return <></>;
  }

  const handleSubmit = async () => {
    setSubmitting(true);
    setError("");

    const result = await onGrantMembership({
      userId: userContext.row.userId,
      tier,
      durationDays: Number(durationDays),
    });

    if (result?.ok) {
      onClose();
      return;
    }

    setError(result?.error || "Failed to grant membership");
    setSubmitting(false);
  };

  return (
    <Dialog
      open={openState}
      onClose={submitting ? undefined : onClose}
      aria-labelledby="grant-membership-dialog-title"
    >
      <DialogTitle id="grant-membership-dialog-title">
        Grant membership to {userContext.row.nickname}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Approve a complimentary membership package for this user directly from the user table.
        </DialogContentText>

        <Typography variant="body2" style={{ marginBottom: 12 }}>
          <strong>User ID:</strong> {userContext.row.userId}
        </Typography>

        <FormControl variant="outlined" fullWidth margin="dense">
          <InputLabel>Tier</InputLabel>
          <Select
            value={tier}
            onChange={(e) => setTier(e.target.value)}
            label="Tier"
          >
            <MenuItem value="premium">Premium</MenuItem>
            <MenuItem value="pro">Pro</MenuItem>
          </Select>
        </FormControl>

        <TextField
          margin="dense"
          label="Duration (days)"
          type="number"
          fullWidth
          variant="outlined"
          value={durationDays}
          onChange={(e) => setDurationDays(Math.max(1, Number(e.target.value) || 1))}
          inputProps={{ min: 1, max: 3650 }}
        />

        <Typography variant="body2" style={{ marginTop: 12 }}>
          This will grant <strong>{tier === "pro" ? "Pro" : "Premium"}</strong> for{" "}
          <strong>{durationDays}</strong> day{durationDays === 1 ? "" : "s"}.
        </Typography>

        {error && (
          <Typography variant="body2" style={{ marginTop: 12, color: "#d32f2f" }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={submitting}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={submitting}>
          {submitting ? "Granting..." : "Approve Grant"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
